const ALLOWED_TAGS = new Set([
    "a",
    "b",
    "br",
    "div",
    "em",
    "i",
    "li",
    "ol",
    "p",
    "span",
    "strong",
    "u",
    "ul",
])

const ALLOWED_ATTRS = {
    a: new Set(["href", "title", "target", "rel"]),
    div: new Set(["class"]),
    span: new Set(["class"]),
}

const SAFE_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"]

function sanitizeElement(element) {
    const tagName = element.tagName.toLowerCase()

    if (!ALLOWED_TAGS.has(tagName)) {
        element.replaceWith(...Array.from(element.childNodes))
        return
    }

    const allowedAttrs = ALLOWED_ATTRS[tagName] || new Set()
    Array.from(element.attributes).forEach((attr) => {
        const attrName = attr.name.toLowerCase()
        const attrValue = attr.value || ""

        if (!allowedAttrs.has(attrName) || attrName.startsWith("on")) {
            element.removeAttribute(attr.name)
            return
        }

        if (attrName === "href") {
            try {
                const parsedUrl = new URL(attrValue, window.location.origin)
                if (!SAFE_PROTOCOLS.includes(parsedUrl.protocol)) {
                    element.removeAttribute(attr.name)
                }
            } catch (_) {
                element.removeAttribute(attr.name)
            }
        }
    })

    if (tagName === "a") {
        element.setAttribute("rel", "noopener noreferrer")
    }
}

export function sanitizeHtml(value) {
    if (!value || typeof value !== "string") return ""
    if (typeof window === "undefined" || typeof window.DOMParser === "undefined") {
        return value.replace(/<[^>]*>/g, "")
    }

    const parser = new window.DOMParser()
    const doc = parser.parseFromString(`<div>${value}</div>`, "text/html")
    const wrapper = doc.body.firstElementChild

    Array.from(wrapper.querySelectorAll("*")).forEach(sanitizeElement)

    return wrapper.innerHTML
}
